import { Link } from 'react-router-dom'
import { getToken } from '../api'

export default function HomePage() {
  const logged = Boolean(getToken())

  return (
    <>
      <section className="hero">
        <div>
          <div className="hero-badge">QUEST ACCEPTED</div>
          <h1>
            把游戏点子
            <br />
            <span className="accent">变成可玩方案</span>
          </h1>
          <p className="lead">
            输入创意主题，立刻生成策划方案、实机美术提示词，并绘制一张能看出玩法的游戏截图。
            注册即可开始，每人默认 3 次生成机会。
          </p>
          <div className="hero-actions stagger">
            <Link className="btn btn-primary" to={logged ? '/create' : '/login'}>
              {logged ? '开始生成策划' : '注册并开始'}
            </Link>
            <Link className="btn btn-secondary" to="/history">
              我的记录
            </Link>
          </div>
        </div>
        <div className="hero-card pixel-frame">
          <div className="preview-frame">
            <video
              className="hero-video"
              src="/hero-preview.mp4"
              autoPlay
              muted
              loop
              playsInline
              poster=""
              aria-label="实机画面预览演示"
            />
          </div>
          <div className="hero-stats">
            <span>PLAN</span>
            <span>PROMPT</span>
            <span>SCREEN</span>
          </div>
        </div>
      </section>

      <section className="section">
        <h2>CORE FEATURES</h2>
        <div className="cards stagger">
          <article className="card">
            <h3>一次三个创意</h3>
            <p>输入构想，立刻得到 3 个玩法真正不同的方案，每案 9 项完整内容。</p>
          </article>
          <article className="card">
            <h3>精选一张概念图</h3>
            <p>从三个方案里选一个生成 1280×720 像素概念图，一批只生一图。</p>
          </article>
          <article className="card">
            <h3>私人存档</h3>
            <p>登录后历史只属于你；每日额度可看，结果长期保存。</p>
          </article>
        </div>
      </section>
    </>
  )
}
